module.exports = __webpack_public_path__ + "static/AkkuratPro-BoldItalic-757d66eb51abe8025db2d72bd3eb8aa3.woff2";